export default [
  {
    label: "Languages",
    text: "Python, JavaScript (ES5/ES6), TypeScript, Golang, SQL, HTML, CSS, Excel VBA",
  },
  {
    label: "Frameworks & Technologies",
    text: "Django, Django REST Framework, DRF, React, Vite, Flask, FastAPI, LangChain, Pydantic, PydanticAI, Pipecat, ElevenLabs, Deepgram, Cloudflare TURN, Langfuse, RunPod, Together AI, lmdeploy, gRPC, Protocol Buffers, protobuf, JWT, Supabase, Deno, PostgreSQL, pgvector, Pinecone, ChromaDB, Elasticsearch, RabbitMQ, Plaid API, Docker, AWS, GCP, Google Cloud Tasks, Ansible, Podman, CircleCI, Datadog, Sentry, Shopify APIs, Google Firebase, Windows Server",
  },
];
